


















import Vue from "vue";
export default Vue.extend({
  props: {
    ScannerData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      innerScannerData: this.ScannerData.LocalPreferenceSettingName_ExternalDevicesConfigurationDict
    };
  },
  methods: {
    handleSwitchChange(e, prop) {
      this.$set(this.innerScannerData, prop, e.checked);
    },
    getData() {
      return {
        LocalPreferenceSettingName_ExternalDevicesConfigurationDict: {
          ScannerSettings_ConfigurationKey_IsEnabled: this.innerScannerData.ScannerSettings_ConfigurationKey_IsEnabled,
          ScannerSettings_ConfigurationKey_PortNumber: this.innerScannerData.ScannerSettings_ConfigurationKey_PortNumber,
          ScannerSettings_ConfigurationKey_ClientIPAddress: this.innerScannerData.ScannerSettings_ConfigurationKey_ClientIPAddress
        }
      };
    }
  }
});
